module.exports = __webpack_public_path__ + "img/bag-check.704cf8ee.svg";